module.exports = __webpack_public_path__ + "static/media/template-tickets.57696578.xlsx";